import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { BookingsRes } from 'features/bookings'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store/AuthContext'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchBookings = (priorityQuery?: string) => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = priorityQuery ?? getCurrentQuery()

	const {
		data: bookings,
		isFetching: isBookingsLoading,
		isSuccess: isBookingsSuccess
	} = useQuery<BookingsRes>({
		queryKey: queryKeys.bookings.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.bookings(query)),
		enabled: !!auth.accessToken
	})

	return {
		bookings,
		isBookingsLoading,
		isBookingsSuccess
	}
}
